import Component from '../core/Component'
import Scroll from '../services/Scroll'

export default class TextClipping extends Component {
    constructor(element) {
        super(element)
    }

    prepare() {
        Scroll.on('resize', this.handleResize)
        this.handleResize()
    }

    destroy() {
        Scroll.off('resize', this.handleResize)
    }

    handleResize = () => {
        this.element.style.backgroundPositionX = -this.element.offsetWidth - 100 + 'px'
    }
}
